var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#E95D1D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.932 18.78c-1.067-1.274-1.093-3.01-.057-3.878 1.036-.866 2.74-.536 3.807.74l5.806 6.934c1.067 1.274 1.093 3.01.057 3.878-1.035.866-2.74.536-3.807-.74l-5.806-6.933Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24.982 11.35c1.258-1.313 3.11-1.58 4.137-.597 1.027.984.84 2.846-.416 4.159L18.426 25.645c-1.257 1.313-3.11 1.58-4.136.597-1.028-.984-.841-2.846.416-4.159L24.982 11.35Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.d009eda3e8a590e8b6f6a06934618500.svg";
export { ForwardRef as ReactComponent };